import clsx from 'clsx';
import {
  useClearRefinements,
  UseClearRefinementsProps,
} from 'react-instantsearch';

export function ClearRefinements({
  excludedAttributes,
}: UseClearRefinementsProps) {
  const { refine, canRefine } = useClearRefinements({
    excludedAttributes,
  });

  return (
    <button
      className={clsx('text-danger-base underline underline-offset-4', {
        hidden: !canRefine,
      })}
      onClick={refine}
    >
      Fjern alle filter
    </button>
  );
}
